import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const supportedLanguages = ['en', 'es', 'zh', 'hi', 'ar', 'pt', 'ru', 'ja', 'he', 'de', 'it', 'fr'];

function HreflangTags() {
  const location = useLocation();
  const { lang } = useParams();
  
  useEffect(() => {
    // Remove existing hreflang tags
    const existingTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
    existingTags.forEach(tag => tag.remove());
    
    // Get current path without language prefix
    const currentPath = location.pathname.replace(`/${lang}`, '') || '/';
    
    // Add hreflang tags for all languages
    supportedLanguages.forEach(language => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = language;
      link.href = `https://tulidu.com/${language}${currentPath}`;
      document.head.appendChild(link);
    });
    
    // Add x-default tag
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = `https://tulidu.com/en${currentPath}`;
    document.head.appendChild(defaultLink);
    
    // Cleanup function
    return () => {
      const tags = document.querySelectorAll('link[rel="alternate"][hreflang]');
      tags.forEach(tag => tag.remove());
    };
  }, [location.pathname, lang]);
  
  return null; // This component doesn't render anything
}

export default HreflangTags; 